
const FounderSection = () => {
  return (
    <section className="py-20 px-4 bg-gray-900">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Image */}
          <div className="flex-1">
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/ea054f6d7ebad684b2ecfb10951ea455.jpeg"
                alt="Adel Saïdani - Fondateur"
                className="w-full h-96 lg:h-[500px] object-cover rounded-lg"
              />
              <div className="absolute bottom-4 left-4 bg-[#FF8A00] text-[#0A0A0A] px-4 py-2 rounded-lg">
                <p className="font-bold">Fondateur</p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
              <span className="text-[#FF8A00]">ADEL SAÏDANI</span> — FONDATEUR
            </h2>
            
            <div className="space-y-6 text-[#EAE7E2] text-lg leading-relaxed">
              <p>
                Photographe et créateur, Adel Saïdani a bâti VYBE™ seul autour d'une passion : l'image.
              </p>
              <p>
                De Paris à Dubaï, il capture des émotions et offre des opportunités à sa communauté de créateurs.
              </p>
              <p className="text-[#FF8A00] font-semibold text-xl">
                "Tout a commencé par une photo ; aujourd'hui, c'est une Maison et une Énergie."
              </p>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a
                href="https://instagram.com/maison.zeus"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-bold rounded-lg hover:scale-105 transition-transform"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                <i className="ri-instagram-line mr-2"></i>
                @maison.zeus
              </a>
              <a
                href="https://instagram.com/adofficielo.zeuslex"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-4 bg-gradient-to-r from-orange-500 to-red-500 text-white font-bold rounded-lg hover:scale-105 transition-transform"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                <i className="ri-instagram-line mr-2"></i>
                @adofficielo.zeuslex
                <span className="text-xs block">2.6M followers</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderSection;
